/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useMemo } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation,useNavigate } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Material Dashboard 2 React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Material Dashboard 2 React routes
import routes from "routes";

// Material Dashboard 2 React contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";

import { supabaseClient } from "./supabase";

import SignIn from "layouts/authentication/sign-in";
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";

import Commandes from "layouts/command";
import AllProducts from "layouts/produit/allproducts";
import Charges from "layouts/billing/charges";

import CommandesAll from "layouts/command/all";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const navigate = useNavigate();
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const [userType,setUserType] = useState(null);
  const [init,setInit] = useState(true);
  const [redirectUser,setRedirectUser] = useState(null);

  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    setInit(false)
    //supabaseClient.auth.signOut()
    supabaseClient.auth.getSession().then(({data,error})=>{
      console.log('Session',data.session)
      if(data.session === null){
        navigate("/authentication/sign-in")
      }else{
        supabaseClient.auth.getUser().then(({data,error})=>{
          console.log("userrrrr",data.user)
          if(data.user.app_metadata.type){
            setUserType(data.user.app_metadata.type)
            let elem = <Navigate to="/tables" />
            if(data.user.app_metadata.type === 'owner'){
              elem = <Navigate to="/dashboard" />
            }
            if(data.user.app_metadata.type === 'admin'){
              elem = <Navigate to="/tables" />
            }
            setInit(true)
            setRedirectUser(elem)
          }
        })
      }
    })
    
  },[])

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  const configsButton = (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="small" color="inherit">
        settings
      </Icon>
    </MDBox>
  );


  const getSideNavRoutes=()=>{
    if(userType === 'owner'){
      return (
        [
          {
            type: "collapse",
            name: "Dashboard",
            key: "dashboard",
            icon: <Icon fontSize="small">dashboard</Icon>,
            route: "/dashboard",
            component: <Dashboard />,
          }
        ]
      )
    }else{
      if (userType === 'admin'){
        return([
      
          {
            type: "collapse",
            name: "Produits",
            key: "tables",
            icon: <Icon fontSize="small">table_view</Icon>,
            route: "/tables",
            component: <Tables />,
          },
          {
            type: "collapse",
            name: "Commandes Bloquées",
            key: "Commandes Bloquées",
            icon: <Icon fontSize="small">remove_shopping_cart</Icon>,
            route: "/commande/blocked",
            component: <Commandes />,
          },
          {
            type: "collapse",
            name: "Tout Les Produits",
            key: "inventaireTout",
            icon: <Icon fontSize="small">inventory_icon</Icon>,
            route: "/all",
            component: <AllProducts />,
          },
          {
            type: "collapse",
            name: "Commandes ",
            key: "Commandes",
            icon: <Icon fontSize="small">shopping_cart</Icon>,
            route: "/commandes",
            component: <CommandesAll />,
          },
          {
            type: "collapse",
            name: "Charges",
            key: "Charges",
            icon: <Icon fontSize="small">credit_score_icon</Icon>,
            route: "/charge",
            component: <Charges />,
          },
          {
            type: "collapse",
            name: "Dashboard",
            key: "dashboard",
            icon: <Icon fontSize="small">dashboard</Icon>,
            route: "/dashboard",
            component: <Dashboard />,
          }
        ])
      }else{
        return([
      
          {
            type: "collapse",
            name: "Produits",
            key: "tables",
            icon: <Icon fontSize="small">table_view</Icon>,
            route: "/tables",
            component: <Tables />,
          },
          {
            type: "collapse",
            name: "Tout Les Produits",
            key: "inventaireTout",
            icon: <Icon fontSize="small">inventory_icon</Icon>,
            route: "/all",
            component: <AllProducts />,
          },
        ])
      }
    }
     
  }
  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName="Material Dashboard 2"
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
            {configsButton}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName="Ma9amy"
            routes={getSideNavRoutes()}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
        </>
      )}
      {layout === "vr" && <Configurator />}
      <Routes>
        {getRoutes(routes)}
        <Route path="*" element={redirectUser} />
      </Routes>
    </ThemeProvider>
  );
}
